// extracted by mini-css-extract-plugin
export default {"section":"AddressInfo_section__5XWGr","billingAddressTitle":"AddressInfo_billingAddressTitle__7o0rR","selectContainer":"AddressInfo_selectContainer__mwRGw"};